<div mat-dialog-content class="form-container">
    <form [formGroup]="datosContratista">
      <h1>Alta Nuevo Contratista</h1>
      <div>
        <h2>Datos Contratista</h2>
        <mat-form-field appearance="outline">
          <mat-label>Nombre Comercial del Contratista</mat-label>
          <input
            matInput
            placeholder="Nombre Comercial"
            formControlName="nombre"
            required
          />
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>CIF</mat-label>
          <input matInput placeholder="CIF" formControlName="cif" required />
        </mat-form-field>
      </div>
      <div>
        <h2>Información de Contacto</h2>
        <mat-form-field appearance="outline">
          <mat-label>Nombre y apellido de Contacto</mat-label>
          <input
            matInput
            placeholder="Nombre y apellido Contacto"
            formControlName="nombreContacto"
            required
          />
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Mail de Contacto</mat-label>
          <input
            matInput
            placeholder="mail"
            formControlName="mailContacto"
            required
          />
        </mat-form-field>
      </div>
      <h2>Seleccione el número de centros:</h2>
      <mat-form-field appearance="outline" class="centros">
        <mat-label>Nº de Centros </mat-label>
        <input matInput type="number" formControlName="numeroCentros" required min="1"/>
        <mat-error>Campo Obligatorio, por favor introduzca el número de centros</mat-error>
      </mat-form-field>
      <div>
        <div class="privacidad">
            <input type="checkbox" id="privacidad" formControlName="policy" />
           <label for="privacidad" id="privacidad" > He leido y acepto la <a href="https://xtensa.es/politica/"  target="_blank">Politica de Privacidad</a></label><br><br>
           <p id="proteccion-contratista">
            El responsable del tratamiento de los datos es INPRONET SOLUTIONS SL. La finalidad de la recogida de datos es la de poder atender sus cuestiones, sin ceder sus datos a terceros.Tiene derecho a saber qué información tenemos sobre usted, corregirla o eliminarla tal y como se explica en nuestra Política de Privacidad.</p><br>
          </div>   
        <button
          type="submit"
          (click)="save($event)"
          [mat-dialog-close]
          [disabled]="datosContratista.invalid"
        >
          Hecho
        </button>
      </div>
    </form>
  </div>
